<template>
  <div>
    <the-day :data="day" />
    <the-activity-gallery :data="activity" />
    <the-charity :data="charity" />
    <the-entry :data="entry" gray />
  </div>
</template>

<script>
import TheDay from '@/components/TheDay'
import TheActivityGallery from '@/components/TheActivityGallery'
import TheCharity from '@/components/TheCharity'
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheDay, TheActivityGallery, TheCharity, TheEntry },
  async asyncData({ app, $winstonLog }) {
    let dayData = ''
    let activityData = {}
    let charityData = {}

    // 极致一天
    try {
      const day = await app.$axios.get('/wbhome/oneDay')
      dayData = (day.data && day.data.data) || ''
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
    }

    // 活动风采
    try {
      const activity = await app.$axios.get('/wbhome/mien')
      activityData = (activity.data && activity.data.data) || []
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
    }

    // 社会公益
    try {
      const charity = await app.$axios.get('/wbhome/publicBenefit')
      charityData = (charity.data && charity.data.data) || []
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
    }

    return {
      day: dayData,
      activity: activityData,
      charity: charityData,
    }
  },
  data() {
    return { entry: ['society', 'campus', 'develop', 'benefit'] }
  },
}
</script>
